import React from "react";

const HTML5Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 512 512"
    >
      <path d="M108.4 0h23v22.8h21.2V0h23v69h-23V46h-21v23h-23.2M206 23h-20.3V0h63.7v23H229v46h-23m53.5-69h24.1l14.8 24.3L313.2 0h24.1v69h-23V34.8l-16.1 24.8-16.1-24.8V69h-22.6m89.2-69h23v46.2h32.6V69h-55.6"></path>
      <path
        fill="#e44d26"
        d="M107.6 471l-33-370.4h362.8l-33 370.2L255.7 512"
      ></path>
      <path fill="#f16529" d="M256 480.5V131h148.3L376 447"></path>
      <path
        fill="#ebebeb"
        d="M142 176.3h114v45.4h-64.2l4.2 46.5h60v45.3H154.4m2 22.8H202l3.2 36.3 50.8 13.6v47.4l-93.2-26"
      ></path>
      <path
        fill="#fff"
        d="M369.6 176.3H255.8v45.4h109.6m-4.1 46.5H255.8v45.4h56l-5.3 59-50.7 13.6v47.2l93-25.8"
      ></path>
    </svg>
  );
};

export default HTML5Icon;
